export default {
  user: state => state.user,
  roles: state => state.roles,
  errors: state => state.errors
};
